import React, { useEffect, useState } from "react";
import styles from "../../styles/Docs/Docs.module.css";
// import MediaQuery from "react-responsive";
import { Btn } from "../../styles/Button.styled";

import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  addAttributes,
  ATTRIBUTE_DELETE_RESET,
  ATTRIBUTE_EDIT_RESET,
  ATTRIBUTES_POST_RESET,
  ATTRIBUTES_RESET,
  deleteAttribute,
  getAttributes,
  getAttributeTypes,
} from "../../actions/attributes";
import { DotsLoader } from "../Loaders/Loader";
import { OptionAutocompleteInputCustom } from "../inputs/AutocompleteInputCustom";
import { Input } from "../inputs/Input";
import { OptionsEditor } from "../inputs/OptionsEditor";
import { Select } from "../inputs/Select";
import { Edit, Remove } from "../../../public/icons";
import { EditAttributePopup } from "../attributes/EditAttributePopup";
import { AttributeItem } from "../attributes/interfacesAttr";
import { AttributeCard } from "../attributes/AttributeCard";
import { AlertTooltip } from "../Spreadsheet/ModTooltip";
import { useMediaQuery } from "react-responsive";
// interface CustomAttribute {
//   type: OptionAutocompleteInputCustom;
//   title: string;
//   value: Record<string, any> | null;
// }
interface Option {
  label: string;
  key: string;
}

export default function Attributes() {
  const dispatch = useAppDispatch();
  const attribute_types = useAppSelector((state) => state.attribute_types);
  const addAttributesState = useAppSelector((state) => state.addAttributes);
  const attributesCommon = useAppSelector((state) => state.attributes);
  const editAttribute = useAppSelector((state) => state.editAttribute);
  const deleteAttributeState = useAppSelector((state) => state.deleteAttribute);

  const user = useAppSelector((state) => state.user);

  const [customAttr, setCustomAttr] = useState(false);
  const [error, setError] = useState("");
  const [errorAttr, setErrorAttr] = useState("");
  const [errorEditAttr, setErrorEditAttr] = useState<Record<string, string>>(
    {},
  );

  const [isOptionsValid, setIsOptionsValid] = useState(true);
  const [openPopupEdit, setOpenPopupEdit] = useState(false);
  const [selectedAttr, setSelectedAttr] = useState<AttributeItem | null>(null);

  const [titleAttr, setTitleAttr] = useState("");
  const [optionsAttr, setOptionsAttr] = useState<Record<string, string> | null>(
    null,
  );
  const [typeAttr, setTypeAttr] =
    useState<OptionAutocompleteInputCustom | null>(null);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });

  //   const handleCheckboxChange = (val: boolean) => {
  //     setMandatory(val);
  //     // setActiveSave(true);
  //   };

  useEffect(() => {
    if (attribute_types.state === "idle") {
      dispatch(getAttributeTypes());
    }
  }, [dispatch, attribute_types]);

  useEffect(() => {
    if (attributesCommon.state === "idle") {
      dispatch(getAttributes(null));
    }
  }, [dispatch, attributesCommon]);

  const handleOptionsUpdate = (options: Option[], isValid: boolean) => {
    const optionsObject = options.reduce(
      (acc, curr) => {
        if (curr.label && curr.key) {
          acc[curr.key] = curr.label;
        }
        return acc;
      },
      {} as Record<string, string>,
    );

    setOptionsAttr(optionsObject);
    setIsOptionsValid(isValid);
  };

  const needsOptions =
    typeAttr?.alias === "radio" || typeAttr?.alias === "select";

  const handleSave = () => {
    if (!typeAttr) {
      setError("Оберіть тип параметру");
      return;
    }
    if (!titleAttr.trim()) {
      setError("Вкажіть назву параметру");
      return;
    }
    if (needsOptions && optionsAttr === null) {
      setErrorAttr("Вкажіть варіанти значень списку");
      return;
    }

    setError("");
    setErrorAttr("");
    dispatch(addAttributes({
      type: typeAttr.id,
      title: titleAttr,
      data: needsOptions ? optionsAttr : null,
    }));
  };

  useEffect(() => {
    if (addAttributesState.state === "success") {
      dispatch({ type: ATTRIBUTES_POST_RESET });
      dispatch({ type: ATTRIBUTES_RESET });

      setTypeAttr(null);
      setTitleAttr("");
      setCustomAttr(false);
    }

    if (addAttributesState.state === "failure") {
      setError(addAttributesState.result.message);
    }
  }, [addAttributesState]);

  useEffect(() => {
    if (deleteAttributeState.state === "success") {
      setSelectedAttr(null);
      dispatch({ type: ATTRIBUTE_DELETE_RESET });
      dispatch({ type: ATTRIBUTES_RESET });
    }

    if (deleteAttributeState.state === "failure") {
      setErrorEditAttr((prevErrors) => ({
        ...prevErrors,
        [selectedAttr?.id as string]: deleteAttributeState.result.message,
      }));
    }
  }, [deleteAttributeState]);

  useEffect(() => {
    if (editAttribute.state === "success") {
      setSelectedAttr(null);
      dispatch({ type: ATTRIBUTE_EDIT_RESET });
      dispatch({ type: ATTRIBUTES_RESET });
    }

    if (editAttribute.state === "failure") {
      setErrorEditAttr((prevErrors) => ({
        ...prevErrors,
        [selectedAttr?.id as string]: editAttribute.result.message,
      }));
    }
  }, [editAttribute]);

  const handleClose = () => {
    setTypeAttr(null);
    setTitleAttr("");
    setCustomAttr(false);
  };

  const handleEditAttr = (singleAttr: AttributeItem) => {
    setOpenPopupEdit(true);
    setSelectedAttr(singleAttr);
  };

  const handleDeleteAttr = (attr: AttributeItem) => {
    setSelectedAttr(attr);
    dispatch(deleteAttribute(attr.id));
  };

  const clearError = () => {
    if (error) setError("");
  };

  return (
    <>
      <section
        className={`${styles.wrapper} ${styles.settings}`}
        onClick={clearError}
      >
        <div className={styles.bigLable}>Налаштування функцій</div>
        {user.permissions["attribute.create"] && (
          <div
            style={{
              backgroundColor: "var(--background)",
              padding: "16px",
              borderRadius: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              marginBottom: isMobile ? "20px" : "30px",
            }}
          >
            <div className={styles.middleLable}>
              Створення атрибутів документів
            </div>

            {!customAttr && (
              <Btn
                type="button"
                $width="200px"
                $color="var(--blue)"
                $marginTop="0"
                onClick={() => {
                  setCustomAttr(true);
                }}
                $background="var(--sidebar-hover)"
                $heightMobile="47px"
                $hoverColor="var(--background)"
              >
                Додати новий атрибут
              </Btn>
            )}

            {customAttr && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                }}
              >
                <div className={styles.input_settings}>
                  <Input
                    label={"Назва атрибуту"}
                    placeholder={"Вкажіть назву"}
                    value={titleAttr}
                    onChange={(e) => setTitleAttr(e)}
                    error={error}
                  />
                  <Select
                    label={"Тип атрибуту"}
                    options={attribute_types.list}
                    value={typeAttr?.id as string}
                    onChange={(e) => {
                      setTypeAttr(e as OptionAutocompleteInputCustom | null);
                      setOptionsAttr(null);
                      setErrorAttr("");
                    }}
                  />
                  {/* <CheckboxSingle
                  label="Обов'язковий до заповнення"
                  checked={mandatory}
                  onChange={handleCheckboxChange}
                /> */}
                </div>
                {(typeAttr?.alias === "radio" ||
                  typeAttr?.alias === "select") && (
                  <div
                    style={{
                      marginBottom: isMobile ? "4px" : "0",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <div style={{ fontSize: "16px" }}>
                      Варіанти значень списку
                    </div>
                    <div className={styles.options_info}>
                      Сформуйте перелік значень, які будуть доступні
                      користувачам для вибору в цьому атрибуті. Кожен пункт має
                      бути унікальним.
                    </div>

                    <OptionsEditor
                      onUpdate={handleOptionsUpdate}
                      style={{
                        overflowY: "auto",
                        maxWidth: isMobile
                          ? "100%"
                          : isTablet
                            ? "50vw"
                            : "28vw",
                        width: "100%",
                      }}
                    />
                  </div>
                )}

                <div
                  className={styles.blockBtn_settings}
                  style={{
                    width: isMobile ? "100%" : isTablet ? "50vw" : "28vw",position:"relative",
                  }}
                >
                  {errorAttr.length > 0 && (
                    <div
                      style={{
                        color: "var(--vivid-pink )",
                        fontSize: 12,
                        paddingLeft: 10,
                        height: 12,
                        margin: "auto",
                        position:"absolute",
                        top: -18
                      }}
                    >
                      {errorAttr}
                    </div>
                  )}

                  <Btn
                    type="button"
                    $width="100%"
                    $color="var(--blue)"
                    $marginTop="0"
                    onClick={handleClose}
                    $background="var(--sidebar-hover)"
                    $heightMobile="47px"
                    $hoverColor="var(--background)"
                  >
                    {addAttributesState.state === "loading" ? (
                      <DotsLoader />
                    ) : (
                      "Відмінити"
                    )}
                  </Btn>

                  <Btn
                    type="button"
                    $width="100%"
                    $color="var(--white)"
                    $marginTop="0"
                    onClick={handleSave}
                    $background="var(--blue)"
                    $heightMobile="47px"
                    disabled={!isOptionsValid}
                    $hoverColor="var(--background)"
                  >
                    {addAttributesState.state === "loading" ? (
                      <DotsLoader />
                    ) : (
                      "Зберегти "
                    )}
                  </Btn>
                </div>
              </div>
            )}
          </div>
        )}

        {user.permissions["attribute.update"] && (
          <div className={styles.blockAttrEdit}>
            <div className={styles.middleLable}>
              Додаткові атрибути документів
            </div>

            <div className={styles.middleText}>
              Налаштуйте додаткові поля для збору специфічної інформації. Ці
              дані будуть доступні для заповнення під час завантаження або
              опрацювання файлів.
            </div>

            {attributesCommon.state === "loading" && !attributesCommon.list?.length && (
              <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
                <DotsLoader />
              </div>
            )}

            {attributesCommon.list && (
              <div className={styles.attributesList}>
                {[...attributesCommon.list]
                  .sort((a, b) => a.title.localeCompare(b.title))
                  .map((attr: any, index: number) => (
                    <div
                      key={attr.type.id + String(index)}
                      className={styles.attrCardRow}
                    >
                      <div style={{ width: isMobile ? "100%" : "none" }}>
                        <AttributeCard
                          key={attr.type.id + String(index)}
                          attr={attr}
                          errorEditAttr={errorEditAttr}
                        />
                        {isMobile && (
                          <div
                            style={{
                              color: "var(--vivid-pink )",
                              fontSize: 11,
                              paddingLeft: 10,
                              textAlign: "right",
                              height: 12,
                            }}
                          >
                            {errorEditAttr[attr.id]
                              ? errorEditAttr[attr.id]
                              : " "}
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <AlertTooltip title="Редагувати" offsetY={-5}>
                          <button
                            onClick={() => handleEditAttr(attr)}
                            className={styles.iconBtn}
                          >
                            <Edit
                              height={isMobile ? 18 : 22}
                              width={isMobile ? 18 : 22}
                            />
                          </button>
                        </AlertTooltip>
                        <AlertTooltip title="Видалити" offsetY={-5}>
                          <button
                            className={styles.iconBtn}
                            onClick={() => handleDeleteAttr(attr)}
                          >
                            <Remove
                              height={isMobile ? 20 : 26}
                              width={isMobile ? 20 : 26}
                            />
                          </button>
                        </AlertTooltip>

                        {!isMobile && errorEditAttr[attr.id] && (
                          <div
                            style={{
                              color: "var(--vivid-pink )",
                            }}
                          >
                            {errorEditAttr[attr.id]}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        )}
      </section>
      {openPopupEdit && selectedAttr && (
        <EditAttributePopup
          handleClose={() => setOpenPopupEdit(false)}
          singleAttr={selectedAttr}
          optionsType={attribute_types}
        />
      )}
    </>
  );
}
